import React from "react";
import styled from "styled-components";
import PageNotAvailableImage from "../../../../../images/placeholders/page-not-available.svg";

const PageNotDis = styled.div`
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-size: 30px;
  text-align: center;
  color: #686868;
`;

const PageNotSubDis = styled.div`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 18px;
  text-align: center;

  color: #555555;
`;
const NotFoundContainer = styled.div`
  text-align: center;
  margin-top: 8%;
`;

const PageNotFound: React.FC = () => {
  return (
    <>
      <PageContainer>
        <div>
          <PageNotDis className="margin-top-30">Page Unavailable</PageNotDis>
          <PageNotSubDis className="margin-top-20">
            This page is no longer available.
            <br />
            It may be inactive or deleted.
          </PageNotSubDis>
        </div>
      </PageContainer>
    </>
  );
};

const PageContainer = ({ children }) => {
  return (
    <NotFoundContainer>
      <div>
        <img src={PageNotAvailableImage} />
      </div>
      {children}
    </NotFoundContainer>
  );
};

export default PageNotFound;
